/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
export const protobufPackage = "api";
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
